import React, { Dispatch, SetStateAction } from "react";
import "./index.scss";

interface IProps {
  isSelected: boolean;
  onClick: (type:string) => void;
  type:string;
}
export const RadioButton = ({ isSelected, onClick,type }: IProps) => {
  return (
    <div className="radio-btn-wrapper">
      {isSelected ? (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          onClick={()=>onClick(type)}
        >
          <rect
            x="0.5"
            y="0.5"
            width="15"
            height="15"
            rx="7.5"
            stroke="#3272BE"
          />
          <circle cx="8" cy="8" r="6" fill="#3272BE" />
        </svg>
      ) : (
        <div className="not-selected" onClick={()=>onClick(type)}></div>
      )}
    </div>
  );
};
